import React from 'react';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';

import * as styles from './styles';

type CrossCircleIconButtonProps = {
  clearInputValue: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined;
} & Pick<React.HTMLProps<HTMLDivElement>, 'className'>;

const CrossCircleIconButton: React.FC<CrossCircleIconButtonProps> = ({
  clearInputValue,
  className,
}: CrossCircleIconButtonProps) => (
  <button onClick={clearInputValue} type="button" css={styles.root} className={className}>
    <CrossCircleIcon label="Clear Search Input" size="small" />
  </button>
);

export default CrossCircleIconButton;
